import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

export const experimentalUserPersonalization: ExperimentalQueries['experimentalUserPersonalization'] =
	async (_, { userId }, { network }) => {
		try {
			const res = await network.cfetch(
				`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`,
				{
					method: 'GET',
				},
			);
			const attributes = await res.json();
			return attributes;
		} catch (e) {
			throw new Error(`/personalization ${e.message}`);
		}
	};
